var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import classNames from 'classnames';
import React from 'react';
import { body } from '../Styles/Colours';
import styles from './StyledIcon.module.css';
var StyledIcon = /** @class */ (function (_super) {
    __extends(StyledIcon, _super);
    function StyledIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyledIcon.getIconSize = function (sizeClass) {
        switch (sizeClass) {
            case '96':
                return {
                    size: 96,
                    padding: 20
                };
            case '64':
                return {
                    size: 64,
                    padding: 14
                };
            case '48':
                return {
                    size: 48,
                    padding: 10
                };
            case '40':
                return {
                    size: 40,
                    padding: 8
                };
            case '32':
                return {
                    size: 32,
                    padding: 6
                };
            case '20':
                return {
                    size: 20,
                    padding: 2
                };
            case '18':
                return {
                    size: 18,
                    padding: 2
                };
            case '16':
                return {
                    size: 16,
                    padding: 0
                };
            case '12':
                return {
                    size: 12,
                    padding: 0
                };
            case '24':
            default:
                return {
                    size: 24,
                    padding: 2
                };
        }
    };
    StyledIcon.prototype.render = function () {
        var _a;
        var _b;
        var sizeValue = StyledIcon.getIconSize(this.props.size);
        var iconBaseStyle = this.props.noSizing
            ? {}
            : {
                minHeight: sizeValue.size,
                height: sizeValue.size,
                maxHeight: sizeValue.size,
                minWidth: sizeValue.size,
                width: sizeValue.size,
                maxWidth: sizeValue.size,
                backgroundColor: this.props.backgroundColour,
                display: 'inline-flex'
            };
        if (!this.props.noPadding)
            iconBaseStyle.padding = !this.props.borderColour ? sizeValue.padding : sizeValue.padding - 1;
        if (this.props.borderColour)
            iconBaseStyle.border = "1px solid " + this.props.borderColour;
        var iconStyles = this.props.style ? __assign(__assign({}, iconBaseStyle), this.props.style) : iconBaseStyle;
        var iconClasses = classNames(this.props.className, (_a = {},
            _a[styles.mouseHover] = !!this.props.onClick,
            _a[styles.noCircularContainer] = this.props.noCircularContainer,
            _a), styles.icon);
        // THESE MUST HAVE A ROOT ELEMENT OF SPAN
        // It's important for the tagging system in rooster that there are no divs in the dom structure.
        return (React.createElement("span", { className: iconClasses, style: iconStyles, onClick: this.props.onClick, "data-test-id": this.props.testId },
            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '100%', height: '100%', fill: (_b = this.props.color) !== null && _b !== void 0 ? _b : body, viewBox: '0 0 24 24', focusable: 'false' },
                React.createElement("g", null, this.props.children))));
    };
    return StyledIcon;
}(React.Component));
export { StyledIcon };
